import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Checkbox from '..';

import './index.css';

class GreenCheckbox extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
  }

  getClassNames() {
    const { className } = this.props;
    return classnames({
      GreenCheckbox: true,
      [className]: true,
    });
  }

  render() {
    const { getClassNames } = this;
    return <Checkbox {...this.props} className={getClassNames()} />;
  }
}

GreenCheckbox.propTypes = {
  className: PropTypes.string,
};

GreenCheckbox.defaultProps = {
  className: '',
};

export default GreenCheckbox;
